module.exports = __webpack_public_path__ + "85ae353b3b18325d46820e078af6e4b1.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-12.cur
// module id = 440
// module chunks = 0